import request from "@/utils/request";

export function getContactUsInformation(params) {
  return request({
    url: "/contact/contact_us_information/get_default/",
    method: "get",
    params,
  });
}

export function getContactUsList(params) {
  return request({
    url: "/contact/contact_form_categories/",
    method: "get",
    params,
  });
}

export function contactUs(data) {
  return request({
    url: "/contact/contact_forms/",
    method: "post",
    data,
  });
}

export function contactUsBriefs(data) {
  return request({
    url: "/contact/contact_form_briefs/",
    method: "post",
    data,
  });
}
